import { ApolloProvider } from '@apollo/client';
import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import { init as i18n } from '@app/i18n';

import client from './apollo';
import App from './App';


/**
 * Initialize i18next
 */
const initI18n = i18n;

/**
 * Wake lock support
 */
const initWakeLock = async () => navigator.wakeLock.request('screen');

if (process.env.NODE_ENV === 'development') {
	loadDevMessages();
	loadErrorMessages();
}

/**
 * Render app once all init functions have run, regardless of their success
 */
Promise.allSettled([initI18n(), initWakeLock()]).then(() =>
	ReactDOM.render(
		<ApolloProvider client={client}>
			<App />
		</ApolloProvider>,
		document.getElementById('root'),
	),
);
